import { connect } from "react-redux";
import FastVerified from "./FastVerified";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { sendUserConfirmation } from "../../../globalState/user/actions";

import { selectedStageSelector } from "./selectors";

let mapStateToProps = (state) => {
  return {
    login: state.user.login,
    email: state.user.email,
    personalMobile: state.user.personalMobile,
    messenger: state.user.messenger,
    stage: selectedStageSelector(state),
  }
};

export default compose(connect(mapStateToProps, { sendUserConfirmation }), withRouter)(FastVerified);




